'use client';

/**
 * MUI icons rendered via a client boundary.
 *
 * `@mui/icons-material` icons are not marked `'use client'`, so rendering them
 * directly inside a Server Component invokes `createSvgIcon` on the server and
 * throws. Re-exporting them from this `'use client'` module lets server pages
 * use them as client references (rendered in the browser, not on the server).
 */
import PhoneInTalkIcon from '@mui/icons-material/PhoneInTalk';
import ScheduleIcon from '@mui/icons-material/Schedule';
import PlaceIcon from '@mui/icons-material/Place';
import LocalFloristIcon from '@mui/icons-material/LocalFlorist';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import DirectionsWalkIcon from '@mui/icons-material/DirectionsWalk';

export {
  PhoneInTalkIcon,
  ScheduleIcon,
  PlaceIcon,
  LocalFloristIcon,
  Inventory2Icon,
  DirectionsWalkIcon,
};
